import React, { useEffect, useState } from 'react';
import { useConsent } from '../hooks/useConsent';
import { Link } from 'react-router-dom';
import { useShellI18n } from '@/features/language/useI18n';
import styles from './CookieBanner.module.css';

export const CookieBanner: React.FC = () => {
  const { isBannerOpen, acceptAll, rejectAll, openSettings } = useConsent();
  const { t } = useShellI18n();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isBannerOpen) {
      // Small delay for animation
      const timer = setTimeout(() => setIsVisible(true), 100);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isBannerOpen]);

  if (!isBannerOpen && !isVisible) return null;

  return (
    <div
      className={`${styles.banner} ${isVisible ? styles.visible : ''}`}
      role="region"
      aria-label={t('Cookie consent banner')}
    >
      <div className={styles.content}>
        <div className={styles.text}>
          <h2 className={styles.title}>{t('We value your privacy')}</h2>
          <p>
            {t(
              'We use necessary technologies for secure Portal operation and optional preference storage for interface settings. You can accept optional preferences, reject them or choose individually.'
            )}{' '}
            <Link to="/privacy-policy" className={styles.link}>
              {t('Privacy Policy')}
            </Link>
            {' | '}
            <Link to="/cookie-policy" className={styles.link}>
              {t('Cookie Policy')}
            </Link>
          </p>
        </div>
        <div className={styles.actions}>
          <button onClick={openSettings} className={styles.buttonOutline}>
            {t('Customize')}
          </button>
          <button onClick={rejectAll} className={styles.buttonOutline}>
            {t('Reject All')}
          </button>
          <button onClick={acceptAll} className={styles.buttonPrimary}>
            {t('Accept All')}
          </button>
        </div>
      </div>
    </div>
  );
};
